import { SlideComponentSentenceMaker } from '@/types/slide';
import { SlideComponentCreator } from './factory';

export class SlideComponentSentenceMakerCreator extends SlideComponentCreator {
    public create(id: string): SlideComponentSentenceMaker {
        return {
            id: id,
            type: 'sentenceMaker',
            pos: {
                x: 0,
                y: 0,
            },
            size: { width: 800, height: 448 },
            content: {
                size: { cols: 10, rows: 4 },
                maxWords: 40,
                difficulty: '',
                language: 'traditional',
                keywords: [],
                sentencePattern: '',
                theme: '',
                writingTechnique: '',
                rhetoric: '',
            },
        };
    }
}
